import { useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './AuthContext'; // Pas het pad aan naar je AuthContext
import './ConfigCompany.css'; // Importeer de bijbehorende CSS
import backicon from './Back Icon.png';
import icon_MyAccount from './My Account Icon.png';
import icon_Logout from './Logout Icon.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import icon_ConfigCompany from './Icon Config Company.png';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import QRCode from 'qrcode.react';
import api from './axios'


const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 1000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    transform: 'scale(1)', // Begin iets kleiner
    transition: 'transform 1s ease-in-out', // Overgangseffect
    borderRadius: '5px', // Afgeronde hoeken
  };
  
const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };


function MyProfile() {
    const { user, updateUser, companyId, logout, companyName } = useAuth();
    const [menu2Open, setMenu2Open] = useState(false);
    const menu2Ref = useRef(null);
    const navigate = useNavigate(); 
    const [activeMenu, setActiveMenu] = useState('personalInfo');  // Standaard is 'personalInfo' actief
    const [fullName, setFullName] = useState('');  
    const [newFullName, setNewFullName] = useState('');  
    const [newEmailAddress, setNewEmailAddress] = useState('');  
    const [newO365_email, setNewO365_email] = useState('');  
    const [currentPassword, setCurrentPassword] = useState('');  
    const [newPassword, setNewPassword] = useState('');  
    const [myEmail, setMyEmail] = useState('');     
    const [myO365_email, setMyO365_email] = useState(''); 
    const [forgotPassword_email, setForgotPassword_email] = useState(''); 
    const [showPopup_FullName, setShowPopup_FullName] = useState(false);
    const [showPopup_MyEmail, setShowPopup_MyEmail] = useState(false);
    const [ShowPopup_MyO365_email, setShowPopup_MyO365_email] = useState(false);
    const [showPopup_MyPassword, setShowPopup_MyPassword] = useState(false);
    const [showPopup_2FA, setShowPopup_2FA] = useState(false);
    const [MFA_enabled, setMFA_enabled] = useState("Off");
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [showQRCode, setShowQRCode] = useState(true); // State om bij te houden of de QR-code of de secret getoond moet worden
    const [OTP_Input, setOTP_Input] = useState('');  
    const [showPopup_RemoveAccount, setShowPopup_RemoveAccount] = useState(false);
    const [ShowPopup_ForgotPassword, setShowPopup_ForgotPassword] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const [reload, setReload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('Support');
    const [Request_message, setRequestMessage] = useState("");
    const [showHelpPopup, setShowHelpPopup] = useState(false);
    const [toggleHandleCheckBoxChange, setToggleHandleCheckBoxChange] = useState(false);
  

    let MFA_secret = ''; // Initialiseer MFA_secret als een lege string

    if (qrCodeUrl.includes('secret=')) {
        const secretPart = qrCodeUrl.split('secret=')[1];
        if (secretPart) {
            MFA_secret = secretPart.split('&')[0];
        }
    }
    
    const toggleQRCode = () => {
      setShowQRCode(!showQRCode); // Wisselt tussen het tonen van de QR-code en de secret
    };

    const activateMFA = async () => {
      try {
        // let de axios‐instance de cookie(s) meezenden
        const { data } = await api.post('/activate_2fa', {
          user_id: user.id,
          token: OTP_Input
        })
  
        // Succes: context updaten en feedback tonen
        updateUser({ mfa_enabled: true })
        setMessage('Two-factor authentication activated successfully')
        setShowPopupMessage(true)
        setTimeout(() => setShowPopupMessage(false), 3000)
        setShowPopup_2FA(false)
  
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
          return
        }
        // overige fouten
        const msg = err.response?.data?.error || err.message
        setError('Error activating two-factor authentication: ' + msg)
        setShowErrorPopup(true)
        setTimeout(() => setShowErrorPopup(false), 3000)
      }
    }

    const disableMFA = async () => {
      try {
        // Stuur de API-aanvraag via je axios-instance (metCredentials → cookie handling)
        await api.post('/disable_2fa', {
          user_id: user.id,
          otp: OTP_Input
        })
  
        // Succes: MFA-status in de context uitzetten en feedback geven
        updateUser({ mfa_enabled: false })
        setMessage('Two-factor authentication disabled successfully')
        setShowPopupMessage(true)
        setTimeout(() => setShowPopupMessage(false), 3000)
        setShowPopup_2FA(false)
  
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
          return
        }
        // andere fouten
        const msg = err.response?.data?.error || err.message
        setError('Error disabling two-factor authentication: ' + msg)
        setShowErrorPopup(true)
        setTimeout(() => setShowErrorPopup(false), 3000)
      }
    }
  
    const fetchMFA_QR_Code = async () => {
      try {
        // API-aanroep via axios-instance, cookies/tokens gaan automatisch mee
        const { data } = await api.post('/generate_2fa', {
          user_id: user.id
        })
  
        // QR-code URL in state opslaan
        setQrCodeUrl(data.qr_code_url)
  
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
          return
        }
        // andere fouten
        const msg = err.response?.data?.error || err.message
        setError('Error generating 2FA QR code: ' + msg)
        setShowErrorPopup(true)
        setTimeout(() => setShowErrorPopup(false), 3000)
      }
    }

  const handleSendHelpButton = async (event) => {
    event.preventDefault()
    setShowHelpPopup(false)

    try {
      // Axios-instance stuurt cookies/tokens automatisch mee
      await api.post('/api/requestforsupport/', {
        user_id:        user.id,
        user_email:     user.email,
        user_name:      user.name,
        company_id:     companyId,
        company_name:   companyName,
        Request_category: selectedCategory,
        Request_message:  Request_message,
        currentURL:     window.location.href
      })

      // Succes
      setMessage('Request for support sent successfully')
      setShowPopupMessage(true)
      setTimeout(() => setShowPopupMessage(false), 3000)

    } catch (err) {
      // 401 → sessie verlopen
      if (err.response?.status === 401) {
        await logout()
        setError('Session expired')
        setShowErrorPopup(true)
        setTimeout(() => setShowErrorPopup(false), 3000)
        navigate(`/login/${companyId}`)
        return
      }
      // Andere fout
      const msg = err.response?.data?.error || err.message
      setError('Error sending request for support: ' + msg)
      setShowErrorPopup(true)
      setTimeout(() => setShowErrorPopup(false), 3000)
    }
  }

    function isValidEmail(email) {
      return emailRegex.test(email);
    }
  
    const updateUserProfile = async (action) => {
      if (!user) return; 

      // Basis payload
      const payload = { userId: user.id, action }
  
      // Vul aan per actie
      switch (action) {
        case 'update_fullname':
          if (user.name === newFullName) {
            setShowPopup_FullName(false)
            return
          }
          payload.new_fullname = newFullName
          break
  
        case 'update_email':
          if (user.email === newEmailAddress) {
            setShowPopup_MyEmail(false)
            return
          }
          if (!isValidEmail(newEmailAddress)) {
            setError('Incorrect e-mail address')
            setShowErrorPopup(true)
            setTimeout(() => setShowErrorPopup(false), 3000)
            return
          }
          payload.new_email = newEmailAddress
          break
  
        case 'update_O365_email':
          if (user.O365_email === newO365_email) {
            setShowPopup_MyO365_email(false)
            return
          }
          if (!isValidEmail(newO365_email)) {
            setError('Incorrect e-mail address')
            setShowErrorPopup(true)
            setTimeout(() => setShowErrorPopup(false), 3000)
            return
          }
          payload.new_O365_email = newO365_email
          break
  
        case 'change_password': {
          const pwRegex = /(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#]).{8,}/
          if (!currentPassword) {
            setError('Enter your current password')
            setShowErrorPopup(true)
            setTimeout(() => setShowErrorPopup(false), 3000)
            return
          }
          if (!pwRegex.test(newPassword)) {
            setError('New password must be at least 8 chars, contain one uppercase, one digit and one special char.')
            setShowErrorPopup(true)
            setTimeout(() => setShowErrorPopup(false), 3000)
            return
          }
          payload.current_password = currentPassword
          payload.new_password = newPassword
          break
        }
  
        case 'forgot_password':
          if (!isValidEmail(forgotPassword_email)) {
            setError('Incorrect e-mail address')
            setShowErrorPopup(true)
            setTimeout(() => setShowErrorPopup(false), 3000)
            return
          }
          payload.email_forgot_password = forgotPassword_email
          break
  
        case 'remove_account':
          // geen extra velden
          break
  
        default:
          return
      }
  
      // Verstuur de aanvraag
      try {
        setIsLoading(true)
        const { data } = await api.post('/api/updateUserProfile', payload)
  
        // 401 → sessie verlopen
        if (data.status === 401) {
          throw { response: { status: 401 } }
        }
  
        if (data.success) {
          // Afhandelen per actie
          switch (action) {
            case 'update_fullname':
              setShowPopup_FullName(false)
              updateUser({ name: newFullName })
              setMessage('Name updated successfully!')
              break
  
            case 'update_email':
              setShowPopup_MyEmail(false)
              updateUser({ email: newEmailAddress })
              setMessage('E-mail updated successfully!')
              break
  
            case 'update_O365_email':
              setShowPopup_MyO365_email(false)
              setMessage('Power BI e-mail updated successfully!')
              break
  
            case 'change_password':
              setShowPopup_MyPassword(false)
              setMessage('Password updated successfully!')
              break
  
            case 'forgot_password':
              setShowPopup_ForgotPassword(false)
              setMessage('Instructions sent to your e-mail')
              break
  
            case 'remove_account':
              setShowPopup_RemoveAccount(false)
              // Clear context
              await logout()
              navigate(`/login`);
              return;
          }
  
          setShowPopupMessage(true)
          setTimeout(() => setShowPopupMessage(false), 3000)
        } else {
          // Fout terug van server
          setError(data.error || 'Operation failed')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
        }
      } catch (err) {
        // 401 → refresh-token mislukt
        if (err.response?.status === 401) {
          await logout()
          setError('Session expired')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
          navigate(`/login/${companyId}`)
        } else {
          setError(err.message || 'Network error')
          setShowErrorPopup(true)
          setTimeout(() => setShowErrorPopup(false), 3000)
        }
      } finally {
        setIsLoading(false)
      }
    }

    const toggleCurrentPasswordVisibility = () => {
      setShowCurrentPassword((prevShowCurrentPassword) => !prevShowCurrentPassword);
    };

    const toggleNewPasswordVisibility = () => {
      setShowNewPassword((prevShowNewPassword) => !prevShowNewPassword);
    };

    const handleMyProfile = () => {
      navigate('/my-profile');
    };

    const handleLogout = async () => {
      // Roept server-side logout aan en ruimt de context op
      await logout()
  
      // Redirect naar login voor de huidige company
      navigate(`/login/${companyId}`)
    }

      const handleSwitchCompany = () => {
        navigate('/my-companies');
      };

      
      const handleClickOutside = (event) => {
        if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
          setMenu2Open(false);
        }
      };


      const handleCheckboxChange = () => {
        if (myEmail === myO365_email) {
          // Als de e-mailadressen al gelijk zijn, doe dan iets specifieks
          setMyO365_email('');
        } else {
          // Als de e-mailadressen niet gelijk zijn, doe dan iets anders
          setMyO365_email(myEmail);

          // Update de kolom O365_email van de gebruiker met login emailadres van de portal
          setNewO365_email(myEmail);
          setIsLoading(true);
          setToggleHandleCheckBoxChange(true);
        }
      };


      useEffect(() => {
        // Alleen triggeren als de toggle true wordt
        if (!toggleHandleCheckBoxChange) return

        const requestData = {
          userId: user.id,
          action: 'update_O365_email',
          myO365_email
        }
    
        const fetchData = async () => {
          try {
            // Axios-instance stuurt automatisch cookies mee en voegt Authorization-header toe via interceptor
            const { data } = await api.post('/api/updateUserProfile', requestData)
    
            if (data.success) {
              setShowPopup_MyO365_email(false)
              setIsLoading(false)
              setMessage('E-mail Power BI license updated successfully!')
              setShowPopupMessage(true)
              setReload(!reload)
            }
          } catch (err) {
            if (err.response?.status === 401) {
              // Token verlopen: log uit via context en navigeer naar login
              await logout()
              setError('Session expired')
              setShowErrorPopup(true)
              setTimeout(() => setShowErrorPopup(false), 3000)
              navigate(`/login/${companyId}`)
            } else {
              console.error('Error updating O365 email:', err)
              setError(err.response?.data?.error || err.message)
              setShowErrorPopup(true)
              setTimeout(() => setShowErrorPopup(false), 3000)
            }
          } finally {
            setToggleHandleCheckBoxChange(false)
          }
        }
    
        fetchData()
      }, [
        toggleHandleCheckBoxChange,
        newO365_email,
        user?.id,
        logout,
        companyId,
        navigate,
        // zet hier alle setters en reload in de deps:
        setShowPopup_MyO365_email,
        setIsLoading,
        setMessage,
        setShowPopupMessage,
        setError,
        setShowErrorPopup,
        setReload,
        reload
      ])

      const handleMenu_Help = () => {
        setShowHelpPopup(true);
      };

      useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        // Opruimen bij ontkoppeling
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []); // Geen afhankelijkheden, alleen bij mounten en ontkoppelen
  

      useEffect(() => {
        if (!user) return  // wacht tot user geladen is
    
        const fetchProfile = async () => {
          try {
            // Axios-instance voegt automatisch token/cookies toe en refresht bij 401
            const { data } = await api.get(`/api/getMyProfile/${user.id}`)
    
            setFullName( data.name        ?? '' )
            setMyEmail(  data.email       ?? '' )
            setMyO365_email(data.O365_email  ?? '' )
          } catch (err) {
            // 401 → logout via interceptor, maar voor de zekerheid:
            if (err.response?.status === 401) {
              await logout()
              navigate(`/login/${companyId}`)
            } else {
              console.error('Profiel opvragen mislukt:', err)
              // herstel defaults
              setFullName('')
              setMyEmail('')
              setMyO365_email('')
            }
          }
        }
    
        fetchProfile()
      }, [
        user?.id,    // herhaal als ingelogde user verandert
        reload,      // herhaal op reload-flag
        logout,
        navigate,
        companyId
      ])
    

    useEffect(() => {
      if (activeMenu === 'reports') {
          // Voorbeeld API-aanroep met fetch:

      }
    }, [activeMenu]);
   
    // Als de gebruiker niet is ingelogd, render dan niets
    if (!user) 
    {
        //+navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina // Redirect naar de loginpagina
        return null;
    }

  return (
    <CSSTransition
      in={true} // Deze waarde verandert wanneer je navigeert
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
    <div className="page">

        <header style={{ borderBottom: '1px solid grey', position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <button className="back-button" onClick={() => navigate(-1)}><img src={backicon} alt="Logo" style={{ height: '5vh', margin: '15px' }} /></button>
            <div className="configCompanies-title">My profile</div>

            <div style={{ position: 'relative' }}>
            <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />
            <img src={icon_MyAccount} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={() => setMenu2Open(!menu2Open)} />
            {menu2Open && (
                <div ref={menu2Ref} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
                <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                    {companyName || 'No company assigned'}
                    {
                      user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                        <a href={`/configcompany/${companyId}`}>
                          <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                        </a>
                      )
                    }
                </div>              
                <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
                <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>
                <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>
                <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
                </div>
            )}
            </div>
        </div>
        </header>

        <div className="sidebar-cc">
            <div className="menu-item-cc" onClick={() => setActiveMenu('personalInfo')}>
                <span className={activeMenu === 'personalInfo' ? 'active' : ''}>Personal info</span>
            </div>
            <div className="menu-item-cc" onClick={() => setActiveMenu('loginAndSecurity')}>
                <span className={activeMenu === 'loginAndSecurity' ? 'active' : ''}>Login and security</span>
            </div>
            <div className="menu-item-cc" onClick={() => setActiveMenu('removeAccount')}>
                <span className={activeMenu === 'removeAccount' ? 'active' : ''} style={{ color: 'red' }}>Remove account</span>
            </div>        
        </div>

        <div className="content-cc">

          {activeMenu === 'personalInfo' && (
            <div className="report-table-container-cc" style={{ width: '900px' }}>
              <h3>Personal Info</h3>
              <div style={{height: '20px'}}></div>
              <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px', width: '850px'}}>
                <tbody style={{ height: '23.4vh'}}>
                  <tr>
                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '350px' }}>
                      Full name
                    </td>
                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px', fontWeight: 'bold' }}>
                      {fullName}
                    </td>
                    <td className="details-cell">
                        <button className="details-button" onClick={() => { setNewFullName(fullName); setShowPopup_FullName(true); }}>Edit</button>
                    </td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid lightgrey' }}> {/* Voeg een borderBottom toe aan deze rij */}
                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '350px' }}>
                        E-mail address
                    </td>
                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px', fontWeight: 'bold' }}>
                        {myEmail}
                    </td>
                    <td className="details-cell">
                        <button className="details-button" onClick={() => { setNewEmailAddress(myEmail); setShowPopup_MyEmail(true); }}>Edit</button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '850px' }} colSpan="2">
                        My login e-mail address is the same as the one I use for Microsoft Power BI
                    </td>
                    <td style={{ verticalAlign: 'middle', textAlign: 'center'}}>
                        {/* Vink het selectievakje aan als myEmail gelijk is aan myO365_email */}
                        <input 
                          type="checkbox" 
                          id="myCheckbox" 
                          name="myCheckbox" 
                          value="SomeValue" 
                          checked={myEmail === myO365_email}
                          onChange={handleCheckboxChange}
                        />
                    </td>
                  </tr>
                  {/* Toon de volgende rij alleen als myEmail niet gelijk is aan myO365_email */}
                  {myEmail !== myO365_email && (
                      <tr>
                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '350px' }}>
                              E-mail address Power BI license
                          </td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px', fontWeight: 'bold' }}>
                              {myO365_email}
                          </td>
                          <td className="details-cell">
                              <button className="details-button" onClick={() => { setNewO365_email(myO365_email); setShowPopup_MyO365_email(true); }}>Edit</button>
                          </td>
                      </tr>
                  )}
                </tbody>
              </table>
            </div>
            )}

          {activeMenu === 'loginAndSecurity' && (
            <div className="report-table-container-cc" style={{ width: '900px' }}>
                <h3>Signing In</h3>
                  <div style={{height: '20px'}}></div>
                  <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px', width: '850px'}}>
                    <tbody style={{ height: '12.5vh'}}>
                      <tr>
                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '350px' }}>
                          Password
                        </td>
                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px', fontWeight: 'bold' }}>
                          ************
                        </td>
                        <td className="details-cell">
                            <button className="details-button" onClick={() => { setCurrentPassword(''); setNewPassword(''); setShowPopup_MyPassword(true); }}>Edit</button>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '350px' }}>
                          Two-factor-authentication
                        </td>
                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px', fontWeight: 'bold' }}>
                          {MFA_enabled}
                        </td>
                        <td className="details-cell">
                            <button className="details-button" onClick={() => { fetchMFA_QR_Code(); setShowPopup_2FA(true); }}>Change</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
            </div>
            )}

          {activeMenu === 'removeAccount' && (
            <div className="report-table-container-cc" style={{ width: '900px' }}>
                <h3>Remove Account</h3>
                  <div style={{height: '20px'}}></div>
                  <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px', width: '850px'}}>
                    <tbody style={{ height: '6.3vh'}}>
                      <tr>
                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '850px' }}>
                          This will complete remove your account and all its settings.
                        </td>
                        <td className="details-cell">
                            <button className="details-button" style={{ color: 'red' }} onClick={() => { setShowPopup_RemoveAccount(true); }}>Remove</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
            </div>
            )}

        </div>

        {showPopup_FullName && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Edit full name</h2>
            <div className="white-space"></div>
            <input
                type="text"
                placeholder="Full name *"
                className="company-name-input"
                value={newFullName}
                onChange={(e) => setNewFullName(e.target.value)}
            />
            <div className="buttons-container">
                <button onClick={() => setShowPopup_FullName(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                    disabled={!newFullName}
                    style={{ color: newFullName ? 'black' : 'grey', fontWeight: newFullName ? 'bold' : 'normal' }}
                    onClick={() => updateUserProfile('update_fullname')}
                >
                    Confirm
                </button>
            </div>
          </div>
        </div>
        )}
        
        {showPopup_MyEmail && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Edit e-mail address</h2>
            <div className="white-space"></div>
            <input
                type="text"
                placeholder="E-mail address *"
                className="company-name-input"
                value={newEmailAddress}
                onChange={(e) => setNewEmailAddress(e.target.value)}
            />
            <div className="buttons-container">
                <button onClick={() => setShowPopup_MyEmail(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                    disabled={!newEmailAddress}
                    style={{ color: newEmailAddress ? 'black' : 'grey', fontWeight: newEmailAddress ? 'bold' : 'normal' }}
                    onClick={() => updateUserProfile('update_email')}
                >
                    Confirm
                </button>
            </div>
          </div>
        </div>
        )}

        {ShowPopup_MyO365_email && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Edit e-mail address Power BI license</h2>
            <div className="white-space"></div>
            <input
                type="text"
                placeholder="E-mail address Power BI license"
                className="company-name-input"
                value={newO365_email}
                onChange={(e) => setNewO365_email(e.target.value)}
            />
            <div className="buttons-container">
                <button onClick={() => setShowPopup_MyO365_email(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                    disabled={!newO365_email}
                    style={{ color: newO365_email ? 'black' : 'grey', fontWeight: newO365_email ? 'bold' : 'normal' }}
                    onClick={() => updateUserProfile('update_O365_email')}
                >
                    Confirm
                </button>
            </div>
          </div>
        </div>
        )}

        {showPopup_MyPassword && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Edit password</h2>
            <div className="white-space"></div>
            <div className="password-input" style={{ marginBottom: '0px' }}>
              <input
                  type={showCurrentPassword ? 'text' : 'password'}
                  id="currentPassword"
                  name="currentPassword"
                  placeholder="Current password *"
                  required
                  onChange={(e) => setCurrentPassword(e.target.value)}
              />
              <button
                  type="button"
                  className="show-hide-button"
                  onClick={toggleCurrentPasswordVisibility}
              >
                  {showCurrentPassword ? <img src="/Media/Show Icon.png" alt="Show" className="show-hide-icon" /> : <img src="/Media/Hide Icon.png" alt="Hide" className="show-hide-icon" />}
              </button>
            </div>
            <div className="link-button-container" style={{ textAlign: 'left', width: '150px' }}>
              <button 
                  className="link-button" 
                  style={{ textAlign: 'left', width: '150px' }} 
                  onClick={() => {
                      setShowPopup_MyPassword(false);
                      
                      //const user = JSON.parse(localStorage.getItem('user'));
                      if (user && user.email) {
                          setForgotPassword_email(user.email);
                      }

                      setShowPopup_ForgotPassword(true);
                  }}
              >
                  Forgot password?
              </button>
            </div>
            <div className='white-space'></div>
            <div className='white-space'></div>

            <div className="password-input">
              <input
                  type={showNewPassword ? 'text' : 'password'}
                  id="newPassword"
                  name="newPassword"
                  placeholder="New password *"
                  required
                  onChange={(e) => setNewPassword(e.target.value)}
              />
              <button
                  type="button"
                  className="show-hide-button"
                  onClick={toggleNewPasswordVisibility}
              >
                  {showNewPassword ? <img src="/Media/Show Icon.png" alt="Show" className="show-hide-icon" /> : <img src="/Media/Hide Icon.png" alt="Hide" className="show-hide-icon" />}
              </button>
          </div>
            <div className="buttons-container">
                <button onClick={() => setShowPopup_MyPassword(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                  disabled={!(newPassword && currentPassword)}
                  style={{ 
                      color: (newPassword && currentPassword) ? 'black' : 'grey',
                      fontWeight: (newPassword && currentPassword) ? 'bold' : 'normal'
                  }}
                  onClick={() => updateUserProfile('change_password')}
              >
                  Confirm
              </button>
            </div>
          </div>
        </div>
        )}

        {showPopup_2FA && (
            <div className="popup-container">
                <div className="popup-content">
                    {MFA_enabled === "Off" && (
                        <>
                            <h2 style={{ fontWeight: 'normal' }}>Two-factor authentication</h2>
                            <div className="white-space"></div>
                            <div>
                                Use an authenticator app like Google Authenticator to scan the QR-code below and generate a one-time password.
                            </div>
                            <div className="qr-code-container" style={{ textAlign: 'center', margin: '20px' }}>
                                {showQRCode ? (
                                    <QRCode value={qrCodeUrl} />
                                ) : (
                                  <div style={{ fontSize: '18px', color: '#333' }}>{MFA_secret}</div> // Toont de secret als tekst als de QR-code niet getoond wordt
                                )}
                            </div>
                            <div className='white-space'></div>
                            <div className='white-space'></div>
                            <button onClick={toggleQRCode}>{showQRCode ? "I can't scan a QR code" : "Show QR code"}</button> {/* Dynamisch wijzigende knoptekst */}
                            <div className='white-space'></div>
                            <div className='white-space'></div>

                            <div className="password-input">
                              <input
                                  type="text"
                                  id="OTP_Code"
                                  name="OTP_Code"
                                  placeholder="One-time password (OTP) *"
                                  required
                                  onChange={(e) => setOTP_Input(e.target.value)}
                              />
                          </div>
                            <div className="buttons-container">
                                <button onClick={() => setShowPopup_2FA(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                                    Cancel
                                </button>
                                <button
                                  disabled={!(OTP_Input)}
                                  style={{ 
                                      color: (OTP_Input) ? 'black' : 'grey',
                                      fontWeight: (OTP_Input) ? 'bold' : 'normal'
                                  }}
                                  onClick={() => activateMFA()}
                              >
                                  Activate
                              </button>
                            </div>
                        </>
                    )}

                    {MFA_enabled === "On" && (
                        <>
                        <h2 style={{ fontWeight: 'normal' }}>Two-factor authentication</h2>
                        <div className="white-space"></div>
                        <div>
                          Your account is currently protected with an extra layer of security. Enter your OTP to disable.
                        </div>
                        <div className='white-space'></div>
                        <div className='white-space'></div>

                        <div className="password-input">
                          <input
                              type="text"
                              id="OTP_Code"
                              name="OTP_Code"
                              placeholder="One-time password (OTP) *"
                              required
                              onChange={(e) => setOTP_Input(e.target.value)}
                          />
                      </div>
                        <div className="buttons-container">
                            <button onClick={() => setShowPopup_2FA(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                                Cancel
                            </button>
                            <button
                              disabled={!(OTP_Input)}
                              style={{ 
                                  color: (OTP_Input) ? 'black' : 'grey',
                                  fontWeight: (OTP_Input) ? 'bold' : 'normal'
                              }}
                              onClick={() => disableMFA()}
                          >
                              Disable
                          </button>
                        </div>
                      </>
                    )}

                </div>
            </div>
        )}


        {showPopup_RemoveAccount && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Remove account</h2>
            <div className="white-space"></div>
            <div>
              Are you sure you want to remove your account?
            </div>
            <div className="white-space"></div>
            <div className="white-space"></div>
            <div className="buttons-container">
                <button onClick={() => setShowPopup_RemoveAccount(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                    style={{ color: 'red', fontWeight: 'bold' }}
                    onClick={() => updateUserProfile('remove_account')}
                >
                    Remove
                </button>
            </div>
          </div>
        </div>
        )}

        {ShowPopup_ForgotPassword && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Forgot password?</h2>
            <div className="white-space"></div>
            <input
                type="text"
                placeholder="E-mail address"
                className="company-name-input"
                value={forgotPassword_email}
                onChange={(e) => setForgotPassword_email(e.target.value)}
            />
            <div className='white-space'></div>
            <div className="buttons-container">
                <button onClick={() => setShowPopup_ForgotPassword(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                    disabled={!forgotPassword_email}
                    style={{ color: forgotPassword_email ? 'black' : 'grey', fontWeight: forgotPassword_email ? 'bold' : 'normal' }}
                    onClick={() => updateUserProfile('forgot_password')}
                >
                    Send instructions
                </button>
            </div>
          </div>
        </div>
        )}

        {showHelpPopup && (
          <div className="popup-container">
              <div className="popup-content">
              <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
              <div className="white-space"></div>
              <b>From:</b>
              <input
                  type="text"
                  placeholder="Username"
                  className="company-name-input"
                  disabled="true"
                  value={user.name || ""}
              />
              <b>Company:</b>
              <input
                  type="text"
                  placeholder="Company name"
                  className="company-name-input"
                  disabled="true"
                  value={companyName || ""}
              />
              <div style={{ display: 'inline-block', marginRight: '10px' }}>
                  <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                  <select 
                    style={{ display: 'inline-block', width: '150px' }}
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                >
                    <option value="Support">Support</option>
                    <option value="Customization request">Customization request</option>
                </select>
              </div>
              <div className="white-space"></div>
              <div className="white-space"></div>
              <b>Message:</b>
              <div className="white-space"></div>
              <textarea
                  placeholder="Request for support message"
                  className="company-name-input"
                  rows="4"
                  value={Request_message}
                  style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                  onChange={(e) => setRequestMessage(e.target.value)}
              ></textarea>
              <div style={{ height: '50px' }}></div>
              <div className="buttons-container">
                  <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                      Cancel
                  </button>
                  <button
                    onClick={handleSendHelpButton}
                    style={{ color: 'black', fontWeight: 'bold' }}
                  >
                  Send request
                  </button>
              </div>
              </div>
          </div>
        )}

        {showPopupMessage && <div className="popup-message">{message}</div>}
        {showErrorPopup && <div className="popup">{error}</div>}
        {isLoading && 
            <div className="loader-wrapper">
            <div className="loader"></div>
            </div>
        }
    </div>
    </CSSTransition>
  );
}

export default MyProfile;